import React from "react";

import { ExportColumnsButton } from "../../../components/dialogs/ExportDialog/ExportColumnsButton";
import { ExportModalBase } from "../../../components/dialogs/ExportDialog/ExportModalBase";
import { ExportTriggerButton } from "../../../components/dialogs/ExportDialog/ExportTriggerButton";
import { useSimpleModal } from "../../../components/dialogs/useSimpleModal";
import { useExportColumns } from "../../../hooks/useExportColumns";
import { useExportColumnsSelection } from "../../../hooks/useExportColumnsSelection";

const ENDPOINT = "customer-articles";

export const CustomerArticlesExportModal = ({ filterValues = {} }) => {
	const exportModal = useSimpleModal();
	const { isLoading, columns, columnsChoices, loadColumns } = useExportColumns(
		`${ENDPOINT}-export-header`
	);

	const onOpen = async () => {
		await loadColumns();
		exportModal.handleOpen();
	};

	return (
		<React.Fragment>
			<ExportTriggerButton label="osfc.buttons.export" isLoading={isLoading} onClick={onOpen} />
			{exportModal.opened && (
				<CustomerArticlesExportView
					viewComponentProps={{ onModalClose: exportModal.handleClose }}
					columns={columns}
					columnsChoices={columnsChoices}
					filterValues={filterValues}
				/>
			)}
		</React.Fragment>
	);
};

const CustomerArticlesExportView = ({
	viewComponentProps,
	columnsChoices,
	columns,
	filterValues = {},
}) => {
	const tableRef = React.useRef(null);
	const { columnsSelected, setColumnsSelected, excludedColumns } =
		useExportColumnsSelection(columns);

	const filters = React.useMemo(() => {
		return {
			...filterValues,
			excluded_columns: excludedColumns,
		};
	}, [filterValues, excludedColumns]);

	const titleButtons = [
		<ExportColumnsButton
			choices={columnsChoices}
			value={columnsSelected}
			onChange={setColumnsSelected}
		/>,
	];

	return (
		<ExportModalBase
			filters={filters}
			endpoint={ENDPOINT}
			tableRef={tableRef}
			{...viewComponentProps}
			titleButtons={titleButtons}
		/>
	);
};
